<div class="vehicle__info__icons d-flex flex-row">
    <div
        class="svgs d-flex align-items-center"
        *ngFor="let feature of featureIcons"
        [title]="feature.name"
    >
        <img
            [ngClass]="{ svgs__small: size === 'small' }"
            [src]="feature.img"
            [alt]="feature.name"
        />
        <span
            *ngIf="feature.quantity !== null && feature.quantity !== undefined"
            [ngClass]="{
                svgs__info__light: color === 'light',
                svgs__info__small: size === 'small'
            }"
            class="svgs__info"
            >{{ feature.quantity }}</span
        >
    </div>
    <div class="svgs d-flex align-items-center" *ngIf="featureFlags">
        <img
            [ngClass]="{ svgs__small: size === 'small' }"
            [src]="icons['seating-' + color] | cdn"
            alt="seating"
        />
        <span
            [ngClass]="{
                svgs__info__light: color === 'light',
                svgs__info__small: size === 'small'
            }"
            class="svgs__info"
            >{{ featureFlags?.passengers }}</span
        >
    </div>
    <div class="svgs d-flex align-items-center" *ngIf="featureFlags">
        <img
            [ngClass]="{ svgs__small: size === 'small' }"
            [src]="icons['bag-' + color] | cdn"
            alt="baggage"
        />
        <span
            [ngClass]="{
                svgs__info__light: color === 'light',
                svgs__info__small: size === 'small'
            }"
            class="svgs__info"
        >
            {{ featureFlags?.luggage ? featureFlags?.luggage : featureFlags?.doors }}
        </span>
    </div>
    <img
        class="svgs"
        [src]="icons['air-' + color] | cdn"
        alt="AC"
        *ngIf="featureFlags?.air"
    />
    <img
        class="svgs"
        [ngClass]="{ svgs__small: size === 'small' }"
        [src]="icons['sound-' + color] | cdn"
        alt="Stereo"
        *ngIf="featureFlags?.radio"
    />
    <img
        class="svgs"
        [ngClass]="{ svgs__small: size === 'small' }"
        [src]="icons['trans-auto-' + color] | cdn"
        alt="AT"
        *ngIf="featureFlags?.transmission === 'automatica'"
    />
    <img
        class="svgs"
        [ngClass]="{ svgs__small: size === 'small' }"
        [src]="icons['transmission-' + color] | cdn"
        alt="MT"
        *ngIf="featureFlags && featureFlags.transmission !== 'automatica'"
    />
</div>
